import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {NumericConfig} from '../../../lsn-numeric/numeric-config.service';

@Component({
    selector: 'app-numeric-input',
    templateUrl: './numeric-input.component.html',
    styleUrls: ['./numeric-input.component.less'],
})
export class NumericInputComponent extends CustomFormControl {
    @Input() type: 'text' | 'password' = 'text';
    @Input() placeholder = '';
    @Input() size: 'large' | 'small' | 'default' = 'default';
    @Input() config: NumericConfig = {};
    @Input() configName: 'default' | 'value10k' | 'value100k' = undefined; // lsnNumeric config key defined in shared.module.ts
    @Input() textOnDisabled = false;
    @Input() prefix: string;
    @Input() suffix: string;
}
